export const DRIVER_TIMEOUT = 250;
export const DRIVER_MAX_WAITING_TIME = 5000;
export const WAIT_FOR_TIMES = Math.round(
  DRIVER_MAX_WAITING_TIME / DRIVER_TIMEOUT,
);

export const MIN_READING_TIME = 500;
